module.exports = __webpack_public_path__ + "static/media/lexin_fangan.71586a3b.png";